<template>

    <div class="product-add">
        <!--form表单-->
        <el-form size="small" ref="form" :model="form" label-width="200px">
            <!--添加门店-->
            <div class="common-form">租赁协议</div>
            <el-form-item label="协议标题" prop="title" :rules="[{ required: true, message: ' ' }]">
                <el-input v-model="form.title" class="max-w460"></el-input>
            </el-form-item>
            <el-form-item label="详情内容">
                <div>
                    <Uediter :text="form.text" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc">
                    </Uediter>
                </div>
            </el-form-item>
            <el-form-item label="协议排序 " prop="sort" :rules="[{ required: true, message: ' ' }]">
                <el-input v-model="form.sort" class="max-w460"></el-input>
            </el-form-item>
            <el-form-item label="协议开关 " prop="switch" :rules="[{ required: true, message: ' ' }]">
                <el-input v-model="form.switch" class="max-w460"></el-input>
                <div class="tips">协议开关(1:开、0:关)</div>
            </el-form-item>

            <!--提交-->
            <div class="common-button-wrapper">
                <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
            </div>


        </el-form>


    </div>

</template>
  
<script>
import SettingApi from '@/api/setting.js';
import Uediter from '@/components/UE.vue';
export default {
    components: {
        /*编辑器*/
        Uediter
    },
    data() {
        return {
            loading: false,
            /*form表单数据*/
            form: {
                title: '',
                text: '',
                sort: '',
                switch: '',
                agreement_type:''
            },
            /*富文本框配置*/
            ueditor: {
                text: '',
                config: {
                    initialFrameWidth: 400,
                    initialFrameHeight: 500
                }
            },

        };
    },
    created() { 
        // this.form.agreement_type = window.location.href.split('=')[1]
        this.form.agreement_type = this.$route.query.url;
    },

    methods: {
        /*获取富文本内容*/
        contentChangeFunc(e) {
            this.form.text = e;
        },
        //提交表单
        onSubmit() {
            let self = this;
            let form = this.form;
            self.$refs.form.validate((valid) => {
                if (valid) {
                    self.loading = true;
                    SettingApi.contractAdd(form, true)
                        .then(data => {
                            self.loading = false;
                            self.$message({
                                message: '恭喜你，添加成功',
                                type: 'success'
                            });
                            self.$router.push('/contract/contract/index');
                        })
                        .catch(error => {
                            self.loading = false;
                        });
                }
            });

        },

    }

};
</script>
  
<style>
.tips {
    color: #ccc;
}
</style>
  


// WEBPACK FOOTER //
// src/views/contract/contract/add.vue